import { useSectionScrollOnArrival } from "../../hooks/useSectionNav";
import WebLayout from "../../layouts/WebLayout";
import AiRecruitment from "./components/AiRecruitment";
import Faq from "./components/Faq";
import Features from "./components/Features";
import GetStarted from "./components/GetStarted";
import Hero from "./components/Hero";
import MobileApp from "./components/MobileApp";
import PricingSection from "./components/Pricing";

const Home = () => {
  useSectionScrollOnArrival();

  return (
    <WebLayout>
      <section id="home">
        <Hero />
      </section>
      <section id="features" className="scroll-mt-16">
        <Features />
      </section>
      <MobileApp />
      <section id="ai" className="scroll-mt-16">
        <AiRecruitment />
      </section>
      <section id="pricing" className="scroll-mt-16">
        <PricingSection />
      </section>
      <GetStarted />
      <section id="faq" className="scroll-mt-16">
        <Faq />
      </section>
    </WebLayout>
  );
};

export default Home;
